import { Component, OnInit } from '@angular/core';
import { CurrentFacilityService } from 'src/app/shared/services';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderDSVComponent implements OnInit {
    public administrativeLoginURL: string;
    public homeURL: string = 'welcome';
    public showFacilityInformation: boolean = false;
    public cartDisallowedRoutes: string[] = ['cart/confirmation', 'welcome'];
    public loginDisallowedRoutes = ['welcome'];
    public widthLogo = '90px';

    constructor(private currentFacilityService: CurrentFacilityService) {}

    ngOnInit(): void {
        this.administrativeLoginURL = this.currentFacilityService.getUrlAdministrative();
    }
}
